<template>
  <BaseFilter
    :title="`${orderModule.order} Filter`"
    @submit="$emit('apply')"
    @reset="$emit('reset')"
    :isChips="isChips"
    newClass="pa-0 ma-0 btn-box background_color primary--text"
    iconSize="15"
    dialogWidth="700"
    @filterDialogOpen="
      getOrderOptions();
      getProjectList(selectedBranch);
    "
  >
    <template #form>
      <v-form ref="orderObjectForm">
        <v-row class="ma-0">
          <v-col cols="6" md="4">
            <SelectField
              id="order_status"
              name="order_status"
              v-model="orderFilters.status"
              :itemsList="orderStatus"
              :multiple="true"
              :label="`select ${statusMapping.orderStatus}`"
              itemText="display_value"
              itemValue="value"
              :dense="true"
              @change="saleOrderFiltersChanged('status', $event)"
            />
          </v-col>
          <v-col cols="6" md="4">
            <SelectField
              id="order_type"
              name="order_type"
              v-model="orderFilters.order_type"
              :itemsList="orderTypes"
              :label="`select ${orderModule.order} type`"
              item-text="display_value"
              item-value="value"
              :dense="true"
              @change="saleOrderFiltersChanged('order_type', $event)"
            />
          </v-col>
          <v-col cols="6" md="4">
            <SelectField
              id="order_segment"
              name="order_segment"
              v-model="orderFilters.segment"
              :itemsList="orderSegmentTypes"
              :label="`select ${orderModule.order} segment`"
              item-text="display_value"
              item-value="value"
              :dense="true"
              @change="saleOrderFiltersChanged('segment', $event)"
            />
          </v-col>
          <v-row class="ma-0">
            <v-col cols="12">
              <span
                class="
                  text-subtitle-1
                  font-weight-bold
                  text-grey text-capitalize
                "
              >
                filter by {{ configurationModule.project }}
              </span>
            </v-col>
            <v-col cols="12" lg="6" class="d-flex align-center">
              <SelectField
                id="project"
                name="project"
                hide-details="auto"
                clearable
                :label="`select ${configurationModule.project}`"
                :itemsList="projectList"
                itemText="name"
                itemValue="id"
                :value="orderFilters.specific_project"
                :menu-props="{ offsetY: true }"
                @change="saleOrderFiltersChanged('specific_project', $event)"
              ></SelectField>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col cols="12">
              <span
                class="
                  text-subtitle-1
                  font-weight-bold
                  text-grey text-capitalize
                "
              >
                filter by Warning
              </span>
            </v-col>
            <v-col cols="12" lg="6" class="d-flex align-center">
              <SelectField
                id="has_warning"
                name="has_warning"
                hide-details="auto"
                clearable
                label="Has Warning"
                :itemsList="binaryChoice"
                itemText="label"
                itemValue="value"
                :value="orderFilters.has_warning"
                :menu-props="{ offsetY: true }"
                @change="saleOrderFiltersChanged('has_warning', $event)"
              ></SelectField>
            </v-col>
            <v-col cols="12" lg="6" class="d-flex align-center">
              <SelectField
                id="warning"
                name="warning"
                hide-details="auto"
                clearable
                v-if="orderFilters.has_warning"
                outlined
                dense
                label="select Warning"
                :itemsList="warningType"
                itemText="display_value"
                itemValue="value"
                :value="orderFilters.warning_code"
                :menu-props="{ offsetY: true }"
                @change="saleOrderFiltersChanged('warning_code', $event)"
              ></SelectField>
            </v-col>
          </v-row>
        </v-row>
        <v-row class="ma-0">
          <v-col cols="12">
            <span
              class="text-subtitle-1 font-weight-bold text-grey text-capitalize"
            >
              filter by date range
            </span>
          </v-col>
          <v-col cols="12" lg="6" xl="6">
            <DatePicker
              id="start_date"
              name="start_date"
              :value="orderFilters.from_date"
              type="date"
              label="start date"
              outlined
              dense
              clearable
              @change="saleOrderFiltersChanged('from_date', $event)"
            ></DatePicker>
          </v-col>
          <v-col cols="12" lg="6" xl="6">
            <DatePicker
              id="end_date"
              name="end_date"
              :value="orderFilters.to_date"
              type="date"
              label="end date"
              outlined
              :min="orderFilters.from_date"
              dense
              clearable
              @change="saleOrderFiltersChanged('to_date', $event)"
            ></DatePicker>
          </v-col>
          <v-col cols="12">
            <SelectField
              id="sort_by"
              name="sort_by"
              clearable
              hide-details="auto"
              outlined
              dense
              label="sort by"
              :itemsList="sortBy"
              item-text="text"
              item-value="value"
              :value="orderFilters.ordering"
              @change="saleOrderFiltersChanged('ordering', $event)"
            ></SelectField>
          </v-col>
        </v-row>
      </v-form>
    </template>
  </BaseFilter>
</template>

<script>
import { bus } from "@/main";
import BaseFilter from "@/components/BaseComponents/BaseFilter.vue";
import { mapState } from "vuex";
import {
  orderModule,
  statusMapping,
  configurationModule,
} from "@/utils/moduleMapping";
export default {
  components: {
    BaseFilter,
  },
  props: {
    value: Boolean,
    isChips: Boolean,
    filter: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      configurationModule,
      orderModule,
      statusMapping,
      binaryChoice: [
        { label: "Yes", value: true },
        {
          label: "No",
          value: false,
        },
      ],
      warningType : [],
      orderStatus: [],
      sortBy: [
        {
          text: "Status",
          value: "status",
        },
        {
          text: "Status (Descending)",
          value: "-status",
        },
        {
          text: "Weight",
          value: "total_weight",
        },
        {
          text: "Weight (Descending)",
          value: "-total_weight",
        },
        {
          text: "Volume",
          value: "total_volume",
        },
        {
          text: "Volume (Descending)",
          value: "-total_volume",
        },
        {
          text: "Reference Number",
          value: "reference_number",
        },
        {
          text: "Reference Number (Descending)",
          value: "-reference_number",
        },
        {
          text: "Customer Name",
          value: "customer_name",
        },
        {
          text: "Customer Name (Descending)",
          value: "-customer_name",
        },
        {
          text: "Order Date",
          value: "execution_date",
        },
        {
          text: "Order Date (Descending)",
          value: "-execution_date",
        },
      ],
      orderBy: [
        {
          title: "Ascending",
          value: "ascending",
        },
        { title: "Descending", value: "descending" },
      ],

      orderTypes: [],
      orderSegmentTypes: [],

      projectList: [],
    };
  },
  computed: {
    ...mapState("userProfile", {
      orderFilters: (state) => state.order_filters,
    }),
    selectedBranch() {
      let obj = this.$helper.getUserDetailsLocalStorage();
      if (obj) {
        return obj.preferred_branch.id;
      } else {
        return null;
      }
    },
  },
  methods: {
    getOrderOptions() {
      bus.$emit("showLoader", true);
      this.$api.orderNew
        .getOrderOptions({ request_type: "filter" })
        .then((res) => {
          this.orderStatus = res?.data?.status;
          this.orderTypes = res?.data?.order_type;
          this.orderSegmentTypes = res?.data?.segment;
          this.warningType = res?.data?.warning_code;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    saleOrderFiltersChanged(key, value) {
      let obj = {};
      obj[key] = value;
      this.$store.commit("userProfile/setFilters", {
        moduleKey: "order_filters",
        payload: obj,
      });
    },
    getProjectList(id) {
      if (id) {
        this.$api.project
          .getProjectList({ limit: "all", branch: id })
          .then((res) => {
            this.projectList = res.data;
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.projectList = [];
      }
    },
  },
};
</script>
